(() => {
  'use strict';
  if (window.pigMetaCateringInstalled) return;
  window.pigMetaCateringInstalled = true;
  const pixel = '526933283168061';
  const key = 'pig-meta-catering-request';
  const qa = new URLSearchParams(window.location.search).get('pig_qa') === '1';
  const read = () => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const write = request => { try { sessionStorage.setItem(key, JSON.stringify(request)); return true; } catch (_) { return false; } };
  let inMemory = null;
  let initialized = false;
  const allowed = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(privacy && privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true && navigator.globalPrivacyControl !== true);
  };
  const initialize = () => {
    if (initialized) return;
    if (!window.fbq) {
      const q = function () { q.callMethod ? q.callMethod.apply(q, arguments) : q.queue.push(arguments); };
      q.push = q; q.loaded = true; q.version = '2.0'; q.queue = [];
      window.fbq = q; if (!window._fbq) window._fbq = q;
      const script = document.createElement('script'); script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    let exists = false;
    try { exists = window.fbq.getState && window.fbq.getState().pixels.some(p => String(p.id) === pixel); } catch (_) {}
    if (!exists) {
      // Shopify's app pixel remains responsible for PageView/ViewContent.
      // This isolated bridge sends only accepted catering leads, with no form PII.
      window.fbq('set', 'autoConfig', false, pixel);
      window.fbq('init', pixel);
    }
    initialized = true;
  };
  const started = () => {
    const request = { id: window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2), time: Date.now(), qa, sent: false };
    inMemory = request; write(request);
  };
  const accepted = () => {
    if (!document.querySelector('[data-pig-catering-success]')) return;
    const request = read() || inMemory;
    if (!request || request.sent || request.qa || qa || request.time > Date.now() || Date.now() - request.time > 3600000 || !allowed()) return;
    request.sent = true; inMemory = request; write(request);
    initialize();
    window.fbq('trackSingle', pixel, 'Lead', { content_name: 'Catering quote accepted', content_category: 'catering' }, { eventID: request.id });
  };
  document.addEventListener('pig:catering-request-started', started);
  document.addEventListener('pig:catering-request-accepted', accepted);
  document.addEventListener('visitorConsentCollected', accepted);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) accepted(); });
  }
  accepted();
})();
